export default __webpack_public_path__ + "static/media/home_ln.862c8a00.svg";